export default class LinearSpline {
    constructor() {
      this.segments = [];
    }
  
    // Step 1: Train on x and y arrays
    train(x, y) {
      if (x.length !== y.length || x.length < 2) {
        throw new Error("x and y must be arrays of equal length with at least two points.");
      }
  
      this.segments = [];
      for (let i = 0; i < x.length - 1; i++) {
        const x0 = x[i], x1 = x[i + 1];
        const y0 = y[i], y1 = y[i + 1];
        const slope = (y1 - y0) / (x1 - x0);
        const intercept = y0 - slope * x0;
  
        this.segments.push({ x0, x1, slope, intercept });
      }
    }
  
    // Step 2: Predict y for a given x using the correct segment
    predict(x) {
      for (const segment of this.segments) {
        if (x >= segment.x0 && x <= segment.x1) {
          return segment.slope * x + segment.intercept;
        }
      }
      throw new Error("x is out of the interpolation range.");
    }
  }
  